import { observer } from "mobx-react-lite"
import React from "react"
import styled from '~/ui/styled'
import { Alert } from "~/ui/primitives"
import { presets } from "./palette"
import {
  Event,
  EventNames,
  FLAG_ACK,
  FriendCommonData,
  FriendStatus,
} from "../../proto"
import { useStores, Message } from "../../models"
import { globalToast } from "~utils"

const Container = styled.View`
  padding: 0px 20px;
  margin: 10px auto;
  flex-direction: row;
`
const Content = styled.Text`
  color: ${presets.grey.smallText};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  line-height: 18px;
`
const Link = styled.Text`
  color: ${presets.blue.bg};
`

const ErrorLink = styled.Text`
  color: ${({ theme }) => theme.colors.danger};
`
interface MessageContactDeletedNotifyProps {
  userId: number
}
export const MessageContactDeletedNotify: React.FC<MessageContactDeletedNotifyProps> = observer(
  ({ userId }) => {
    const { eventStore, userStore } = useStores()
    const handleInvited = () => {
      const user = userStore.users.get(userId.toString())
      const evt = new Event<FriendCommonData>(EventNames.FRIEND_ADD, {
        username: user.username,
      })
      eventStore.publish(evt, { flags: FLAG_ACK })
      Alert.alert("发送成功", "", [{ text: "OK" }])
    }
    return (
      <Container>
        <Content>
          你还不是他(她)的朋友。请先发送朋友邀请，对方通过验证后，才能聊天。
          <Link onClick={handleInvited} textColor={presets.blue.bg}>
            发送邀请
          </Link>
        </Content>
      </Container>
    )
  },
)

export const MessageContactCreateNotify: React.FC = () => {
  return (
    <Container>
      <Content>现在我们是朋友了，可以开始聊天了</Content>
    </Container>
  )
}

export const MessageContactCreateButNotApprovedNotify: React.FC = () => {
  return (
    <Container>
      <Content>你还不是他(她)的朋友。请通知对方加你为好友，来保持最优良的聊天品质。</Content>
    </Container>
  )
}

export const MessageMessageCreateButNotApprovedNotify: React.FC<{ message: Message }> = observer(
  ({ message }) => {
    const { eventStore, userStore, friendStore, contactStore, blackListStore } = useStores()
    const { currentUser } = userStore
    const id = currentUser.id
    const user_id = id === message.receiver.id ? message.sender.id : message.receiver.id
    const user = userStore.users.get(user_id.toString())
    const friend = friendStore.friendsByUserId(user_id)
    const contact = contactStore.byUserId(user_id)
    const isBlack = !!blackListStore.black_list.get(`${user_id}`)

    const handleApprove = () => {
      const evt = new Event<FriendCommonData>(EventNames.FRIEND_APPROVE, {
        username: user.username,
      })
      eventStore.publish(evt, { flags: FLAG_ACK })
      globalToast.show("发送成功")
    }

    const handleAddFriend = () => {
      const evt = new Event<FriendCommonData>(EventNames.FRIEND_ADD, {
        username: user.username,
      })
      eventStore.publish(evt, { flags: FLAG_ACK })
      globalToast.show("发送成功")
    }

    const handleAddBlack = () => {
      blackListStore.publicAddBlacklist(user_id)
    }
    return (
      <Container>
        <Content>
          他(她)还不是你的朋友。你可以新增他为好友，来保持最优良的聊天品质。
          {!isBlack && (
            <>
              {friend && friend.status === FriendStatus.PENDING ? (
                <Link onClick={handleApprove}>同意邀请</Link>
              ) : !contact ? (
                <Link onClick={handleAddFriend}>加入好友</Link>
              ) : null}
              {!contact && !isBlack && (
                <>
                  /<ErrorLink onClick={handleAddBlack}>加入黑名單</ErrorLink>
                </>
              )}
            </>
          )}
        </Content>
      </Container>
    )
  },
)
export const MessageNotifyCommon: React.FC<{ message: Message }> = ({ message }) => {
  return (
    <Container>
      <Content>{message.content}</Content>
    </Container>
  )
}

export const MessageFriendAddedButNotApprovedNotify: React.FC = () => {
  return (
    <Container>
      <Content>已加为好友。</Content>
    </Container>
  )
}
